import { render } from "./Particles.vue?vue&type=template&id=63e09c67&scoped=true"
import script from "./Particles.vue?vue&type=script&lang=js"
export * from "./Particles.vue?vue&type=script&lang=js"

import "./Particles.vue?vue&type=style&index=0&id=63e09c67&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e09c67"]])

export default __exports__